import * as React from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

function Info({ amount, bonus }) {
  return (
    <React.Fragment>
      <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
        Payment
      </Typography>
      <Typography variant="h4" gutterBottom>
        S${amount}
      </Typography>
      <List disablePadding>
        <ListItem key="bonus" sx={{ py: 1, px: 0 }}>
          <ListItemText
            sx={{ mr: 2 }}
            primary="Free"
            secondary=""
          />
          <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
            S${bonus}
          </Typography>
        </ListItem>
        <ListItem key="amount" sx={{ py: 1, px: 0 }}>
          <ListItemText
            sx={{ mr: 2 }}
            primary="Get"
          />
          <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
            S${amount + bonus}
          </Typography>
        </ListItem>
      </List>
    </React.Fragment>
  );
}

export default Info;
